/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerSaveAsVersionMutationResponse } from "../../models/aiAgentV2Controller/AiAgentV2ControllerSaveAsVersion";

function getAiAgentV2ControllerSaveAsVersionUrl() {
  const res = { method: 'POST', url: `/api/v1/ai-agent-v2/save-as-version` as const }  
  return res
}

/**
 * @description Applies the user's accept/reject decisions and saves the result as a new version in the document version chain. variant 'tracked' (default) keeps accepted changes as tracked-change markup; 'clean' applies them. Triggers the standard ingestion pipeline.
 * @summary Save the redlined DOCX as a new version of the original document
 * {@link /api/v1/ai-agent-v2/save-as-version}
 */
export async function aiAgentV2ControllerSaveAsVersion(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiAgentV2ControllerSaveAsVersionMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getAiAgentV2ControllerSaveAsVersionUrl().url.toString(), ... requestConfig })  
  return res.data
}